angular.module('files')
    .factory('FileAssociation', function ($resource) {
        return $resource('/crm/api/file-association-:type/:id/files/:association', {}, {
            save: {method: 'POST', isArray: true},
            delete: {method: 'DELETE'}
        });
    })
    .service('FileAssociationService', function ($rootScope, modals, $filter, FileAssociation) {
        this.unbind = (fileAssociation, resource) => {
            let content = `Czy chcesz usunąć powiązanie z plikiem <b>${fileAssociation.file.filename}</b>?`;

            let deleteAssociation = () => {
                let params = {};
                params.type = $filter('lowercase')(resource.type);
                params.id = resource.id;
                params.association = fileAssociation.id;

                return FileAssociation.delete(params).$promise.then(() => $rootScope.$broadcast("file.saved"));
            };
            modals.confirm(content, deleteAssociation)
        };
    })
